import axios, { AxiosResponse } from 'axios';

import { ETypUdalosti } from 'enums/akcionarKorpAkce/typUdalosti';

export interface IPrehledKorporatniAkce {
    offset: number;
    limit: number;
    count: number;
    order: string;
    sezudalosti: ISezudalostiKorporatniAkce[];
}
export interface ISezudalostiKorporatniAkce {
    id: number;
    isin: string;
    nazevemise: string;
    datumkonani: Date;
    rozhodnyden: Date;
    typudalosti: ETypUdalosti;
    vypis?: 'ODESLANO' | 'HOTOVO';
    rozpracovano?: boolean;
    predano?: Date;
    potvrzeno?: Date;
}

const prehledKorporatniAkceApi = () => {
    return axios({
        method: 'GET',
        url: 'SRD/Prehled'
    }).then((resp: AxiosResponse<IPrehledKorporatniAkce>) => resp.data.sezudalosti);
};
export default prehledKorporatniAkceApi;
